import { useQuery } from "react-query";
import { handleResponse, storageBucket } from "../utils";

const useGetConfig = ({ product, queryConfig, queryKey }: { product: string, queryConfig: any, queryKey: string }) => {
  const queryFn = () => fetch(`${storageBucket}/config/${product}/config.json`, { method: 'GET' }).then(res => handleResponse(res));

  return useQuery([queryKey, product], queryFn, queryConfig)
}

export default useGetConfig